var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHunterCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1018 10.8127C14.1018 10.8127 14.285 11.1853 15.0581 10.8127L14.2715 11.9999L13.5763 12.3306L14.1018 10.8127Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57382 10.8127C5.57382 10.8127 5.39067 11.1853 4.61761 10.8127L5.40418 11.9999L6.09943 12.3306L5.57382 10.8127Z",
    fill: "#4F4F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3691 7.41878C15.3691 6.87853 14.931 6.44077 14.3907 6.44077C13.8508 6.44077 13.4124 6.87853 13.4124 7.41878C13.4124 7.75408 13.5821 8.04978 13.8395 8.22603C11.5361 14.374 10.5446 8.54481 10.3259 6.92719C10.739 6.74533 8.96889 6.74533 9.38199 6.92719C9.16326 8.54481 8.17173 14.374 5.86826 8.22603C6.1258 8.04978 6.29543 7.75407 6.29543 7.41878C6.29543 6.87853 5.8571 6.44077 5.3171 6.44077C4.77685 6.44077 4.33878 6.87853 4.33878 7.41878C4.33878 7.89505 4.68041 8.2912 5.13196 8.37804C5.16815 9.55416 5.33032 12.8426 6.00549 13.6241C6.00549 13.6241 6.63732 14.6668 9.85393 14.6456C13.0705 14.6668 13.7023 13.6241 13.7023 13.6241C14.3775 12.8426 14.5397 9.55415 14.5759 8.37804C15.0274 8.29119 15.3691 7.89504 15.3691 7.41878Z",
    fill: "#4F4F4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4314 7.20887C12.0441 19.4306 10.5348 4.9834 10.5348 4.9834H9.85413H9.17347C9.17347 4.9834 7.66407 19.4306 3.27684 7.20887L2.25629 7.26126C2.25629 7.26126 2.34929 14.825 3.67612 16.3596C3.67612 16.3596 4.69007 18.0337 9.85413 17.9993C15.0181 18.0337 16.0321 16.3596 16.0321 16.3596C17.3589 14.825 17.4519 7.26126 17.4519 7.26126L16.4314 7.20887Z",
    fill: "url(#paint0_linear_235_10787)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8539 6.44098C10.1596 6.44098 10.4475 6.36647 10.7029 6.2371C10.5876 5.49175 10.5346 4.9834 10.5346 4.9834H9.8539H9.17324C9.17324 4.9834 9.1201 5.4918 9.00485 6.2371C9.26025 6.36647 9.5481 6.44098 9.8539 6.44098Z",
    fill: "#797979"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8881 7.26146C16.8881 7.26146 16.795 14.8252 15.4682 16.3598C15.4682 16.3598 14.4888 17.9711 9.57214 17.9986C9.66545 17.9992 9.75759 18.0001 9.85378 17.9995C15.0178 18.0339 16.0317 16.3598 16.0317 16.3598C17.3586 14.8251 17.4515 7.26144 17.4515 7.26144H16.8881V7.26146Z",
    fill: "#797979"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08085 11.8663C5.77701 12.5061 4.43494 10.4367 3.27637 7.20892L2.72318 7.23734C4.17172 11.2625 5.92224 12.8472 7.08085 11.8663Z",
    fill: "url(#paint1_linear_235_10787)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5891 11.8663C13.8929 12.5061 15.2351 10.4367 16.3936 7.20892L16.9468 7.23734C15.4982 11.2625 13.7477 12.8472 12.5891 11.8663Z",
    fill: "url(#paint2_linear_235_10787)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7381 3.88413C11.7381 4.92461 10.8941 5.76845 9.85378 5.76845C8.81341 5.76845 7.96945 4.92463 7.96945 3.88413C7.96945 2.84381 8.8134 1.99994 9.85378 1.99994C10.894 1.99994 11.7381 2.84381 11.7381 3.88413Z",
    fill: "url(#paint3_radial_235_10787)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0163 8.30694C16.3014 8.59792 16.6982 8.77899 17.1375 8.77899C17.2285 8.77899 17.3171 8.76956 17.4039 8.7547C17.4441 7.85992 17.4515 7.26119 17.4515 7.26119L16.431 7.2088C16.2898 7.60216 16.1516 7.96743 16.0163 8.30694Z",
    fill: "#797979"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7079 6.39747C18.7079 7.26441 18.0045 7.96769 17.1376 7.96769C16.2706 7.96769 15.5673 7.26441 15.5673 6.39747C15.5673 5.53053 16.2707 4.82733 17.1376 4.82733C18.0045 4.82733 18.7079 5.53054 18.7079 6.39747Z",
    fill: "url(#paint4_radial_235_10787)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27684 7.2088L2.25629 7.26119C2.25629 7.26119 2.2635 7.8448 2.30225 8.72004C2.43653 8.75744 2.57746 8.77899 2.7236 8.77899C3.1082 8.77899 3.46012 8.64014 3.7332 8.41047C3.58463 8.04191 3.43263 7.64275 3.27684 7.2088Z",
    fill: "#797979"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999939 6.39747C0.999939 7.26441 1.70323 7.96769 2.57016 7.96769C3.43711 7.96769 4.14043 7.26441 4.14043 6.39747C4.14043 5.53053 3.4371 4.82733 2.57016 4.82733C1.70324 4.82733 0.999939 5.53054 0.999939 6.39747Z",
    fill: "url(#paint5_radial_235_10787)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3998 15.2709C16.3998 15.2709 15.3253 17.045 9.85383 17.0088C4.38233 17.045 3.30782 15.2709 3.30782 15.2709C3.2013 15.1483 3.10685 14.9807 3.01501 14.7926C3.19157 15.4845 3.40743 16.0489 3.67582 16.3595C3.67582 16.3595 4.68977 18.0336 9.85383 17.9992C15.0178 18.0336 16.0318 16.3595 16.0318 16.3595C16.3002 16.0489 16.5161 15.4845 16.6926 14.7926C16.6007 14.9807 16.5063 15.1483 16.3998 15.2709Z",
    fill: "url(#paint6_linear_235_10787)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30782 15.5465C3.30782 15.5465 4.38233 17.3206 9.85383 17.2844C15.3253 17.3206 16.3998 15.5465 16.3998 15.5465C16.442 15.498 16.4819 15.4409 16.5209 15.3795C16.5818 15.1974 16.6392 15.0017 16.6926 14.7926C16.6007 14.9807 16.5063 15.1483 16.3998 15.2709C16.3998 15.2709 15.3253 17.045 9.85383 17.0088C4.38233 17.045 3.30782 15.2709 3.30782 15.2709C3.2013 15.1483 3.10685 14.9807 3.01501 14.7926C3.06841 15.0017 3.12579 15.1974 3.18666 15.3795C3.22572 15.4409 3.26564 15.498 3.30782 15.5465Z",
    fill: "#B6B6B6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.36925 15.7885C3.36925 15.7885 4.43371 17.5459 9.85391 17.5101C15.2741 17.5459 16.3386 15.7885 16.3386 15.7885C16.3803 15.7404 16.4199 15.6838 16.4586 15.623C16.5188 15.4426 16.5757 15.2488 16.6286 15.0417C16.5376 15.228 16.444 15.3941 16.3386 15.5155C16.3386 15.5155 15.2742 17.273 9.85392 17.2371C4.43373 17.273 3.36926 15.5155 3.36926 15.5155C3.26373 15.3941 3.17017 15.228 3.07919 15.0417C3.13211 15.2488 3.18893 15.4426 3.24923 15.623C3.28793 15.6838 3.32745 15.7404 3.36925 15.7885Z",
    fill: "url(#paint7_linear_235_10787)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_235_10787",
    x1: 2.25629,
    y1: 11.4916,
    x2: 17.4519,
    y2: 11.4916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1961,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3569,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6549,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7843,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8902,
    stopColor: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_235_10787",
    x1: 6.62276,
    y1: 12.3891,
    x2: 2.94533,
    y2: 7.79229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1725,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3804,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8078,
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#565656"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_235_10787",
    x1: 13.092,
    y1: 12.3346,
    x2: 16.6212,
    y2: 7.91573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1922,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6196,
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8275,
    stopColor: "#656565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E4E4E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_235_10787",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.91307 2.93518) scale(2.72868)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_235_10787",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.1079 5.62644) scale(2.2104)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606060"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_235_10787",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.57019 5.50781) scale(2.42225)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_235_10787",
    x1: 3.01502,
    y1: 16.3962,
    x2: 16.6926,
    y2: 16.3962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1961,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7843,
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A7A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_235_10787",
    x1: 3.07918,
    y1: 16.2761,
    x2: 16.6286,
    y2: 16.2761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1725,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3804,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6588,
    stopColor: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAAAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHunterCrown);
export default __webpack_public_path__ + "static/media/hunter-crown.f4e0f76d9bcef0a28a61baf4792cc3b6.svg";
export { ForwardRef as ReactComponent };